import { Children as o } from "react";
function i(t, n) {
  return (r) => {
    e(t, r), e(n, r);
  };
}
function e(t, n) {
  typeof t == "function" ? t(n) : t && (t.current = n);
}
function f(t) {
  return !t && typeof t != "number" ? "" : typeof t == "object" && t.props ? o.map(
    t.props.children,
    (n) => f(n)
  ).join("") : String(t);
}
function s(t) {
  return !!t && /^https?:\/\//.test(t);
}
function p(...t) {
  return (...n) => t.forEach((r) => r && r(...n));
}
function a(t, n) {
  return (n.find(({ id: r }) => t === r) || { message: null }).message;
}
function g(t, n) {
  return o.toArray(t).filter(
    (r) => (r == null ? void 0 : r.type) === n
  );
}
export {
  p as callAll,
  g as filterChildrenByType,
  a as getErrorMessage,
  f as getText,
  s as isExternalLink,
  i as mergeRefs
};
